<template lang="html">
  <input type="text"
         v-bind:value="formattedValue"
         v-on:change="change"
         v-money="{ precision, decimal, thousands, prefix, suffix, allowBlank, maxLength }"
         class="v-money" />
</template>

<script>
import money from './directive'
import defaults from './options'
import { format, unformat } from './utils'

export default {
  name: 'Money',
  props: {
    value: {
      required: true,
      default: ''
    },
    masked: {
      type: Boolean,
      default: false
    },
    precision: {
      type: Number,
      default: () => defaults.precision
    },
    decimal: {
      type: String,
      default: () => defaults.decimal
    },
    thousands: {
      type: String,
      default: () => defaults.thousands
    },
    prefix: {
      type: String,
      default: () => defaults.prefix
    },
    suffix: {
      type: String,
      default: () => defaults.suffix
    },
    allowBlank: {
      type: Boolean,
      default: () => defaults.allowBlank
    },
    maxLength: {
      type: Number,
      default: null
    }
  },

  directives: { money },

  data () {
    return {
      formattedValue: ''
    }
  },

  watch: {
    value: {
      immediate: true,
      handler (newValue, oldValue) {
        if (newValue !== '' && newValue != null) {
          var formatted = format(newValue, this.$props)
          if (formatted !== this.formattedValue) {
            this.formattedValue = formatted
          }
        } else if (this.allowBlank) {
          // valor limpo externamente (ex.: trigger de evento sem retorno) não pode manter o número antigo na tela
          this.formattedValue = ''
        }
      }
    }
  },

  methods: {
    change (evt) {
      if (evt.target.value !== '' && evt.target.value != null) {
        this.$emit('input', this.masked ? evt.target.value : unformat(evt.target.value, this.precision))
      } else {
        this.$emit('input', null)
      }
    }
  }
}
</script>
